export enum FilterOperator {
  EQUAL_TO = "EQUAL_TO",
  LESS_THAN = "LESS_THAN",
  LESS_OR_EQUAL = "LESS_OR_EQUAL",
  GREATER_THAN = "GREATER_THAN",
  GREATER_OR_EQUAL = "GREATER_OR_EQUAL"
}
